import React from "react";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";

// core components
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Button from "components/CustomButtons/Button.js";

import stylesAlert from "assets/jss/material-dashboard-pro-react/views/sweetAlertStyle.js";
import stylesModal from "assets/jss/material-dashboard-pro-react/views/notificationsStyle.js";
import stylesCheckbox from "assets/jss/material-dashboard-pro-react/views/regularFormsStyle";
import Close from "@material-ui/icons/Close";
import Slide from "@material-ui/core/Slide";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import CustomInput from "components/CustomInput/CustomInput.js";
import PropTypes from "prop-types";

import axios from "axios";

import { cardTitle } from "assets/jss/material-dashboard-pro-react.js";

const { REACT_APP_SERVER_URL } = process.env;

axios.defaults.withCredentials = true;

const stylesCard = {
  cardIconTitle: {
    ...cardTitle,
    marginTop: "15px",
    marginBottom: "0px",
    textAlign: "left",
  },
};

const stylesSize = {
  size: {
    fontSize: "large",
    color: "black",
    opacity: 1,
    textAlign: "left",
  },
};

const stylesList = {
  list: {
    display: "inline",
    padding: "5px",
  },
};

const styleHeading = {
  heading: {
    fontWeight: "bold",
    textAlign: "center",
  },
};

const useStylesCheckbox = makeStyles(stylesCheckbox);
const useStylesAlert = makeStyles(stylesAlert);
const useStylesModal = makeStyles(stylesModal);

const useStylesCard = makeStyles(stylesCard);
const useStylesList = makeStyles(stylesList);
const useStylesHeading = makeStyles(styleHeading);
const useStylesSize = makeStyles(stylesSize);

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="down" ref={ref} {...props} />;
});

export default function CommonDataElements(props) {
  const classesAlert = useStylesAlert();
  const classesCard = useStylesCard();
  const classesList = useStylesList();
  const classesCheckbox = useStylesCheckbox();
  const classesModal = useStylesModal();
  const classesHeading = useStylesHeading();
  const classesSize = useStylesSize();

  const classes = {
    ...classesAlert,
    ...classesModal,
    ...classesCard,
    ...classesList,
    ...classesCheckbox,
    ...classesHeading,
    ...classesSize,
  };

  const [submitState, setSubmitState] = React.useState(false);
  const [requestDataModal, setRequestDataModal] = React.useState(false);
  const [name, setName] = React.useState(props.userInfo.name || "");
  const [email, setEmail] = React.useState(props.userInfo.email || "");

  const [emailState, setEmailState] = React.useState("success");
  const [institution, setInstitution] = React.useState(
    props.userInfo.institution || ""
  );
  const [description, setDescription] = React.useState("");

  const verifyEmail = (email) => {
    const emailRex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if (emailRex.test(email)) {
      return true;
    }
    return false;
  };

  const handleSubmitRequestData = async (e) => {
    e.preventDefault();

    const postValues = {
      name: name,
      email: email,
      institution: institution,
      description: description,
      type: "cde",
    };

    let dataRequest;

    try {
      dataRequest = await axios.post(
        `${REACT_APP_SERVER_URL}/data_requests`,
        {
          ...postValues,
        },
        {
          withCredentials: true,
        }
      );
    } catch ({ response }) {
      dataRequest = response;
    }
    if (dataRequest.status == 200) {
      console.log("success");
      setSubmitState(true);
    } else {
      console.log("something went wrong");
      setSubmitState(true);
    }

    setRequestDataModal(false);
  };

  return (
    <div>
      <Dialog
        classes={{
          root: classes.center + " " + classes.modalRoot,
          paper: classes.modal,
        }}
        open={requestDataModal}
        TransitionComponent={Transition}
        keepMounted
        onClose={() => setRequestDataModal(false)}
        aria-labelledby="notice-modal-slide-title"
        aria-describedby="notice-modal-slide-description"
      >
        <DialogTitle
          id="notice-modal-slide-title"
          disableTypography
          className={classes.modalHeader}
        >
          <Button
            justIcon
            className={classes.modalCloseButton}
            key="close"
            aria-label="Close"
            color="transparent"
            onClick={() => {
              setRequestDataModal(false);
            }}
          >
            <Close className={classes.modalClose} />
          </Button>
          <h4 className={classes.modalTitle}>Submit Data Request</h4>
        </DialogTitle>
        <DialogContent
          id="notice-modal-slide-description"
          className={classes.modalBody}
        >
          <div className={classes.modalBody}>
            <GridContainer>
              <GridItem xs={12} sm={12} md={12}>
                <form onSubmit={handleSubmitRequestData}>
                  <GridContainer>
                    <GridItem xs={12} sm={12} md={12}>
                      <CustomInput
                        labelText="Name"
                        id="name"
                        formControlProps={{
                          fullWidth: true,
                        }}
                        inputProps={{
                          value: name,
                          onChange: (event) => {
                            setName(event.target.value);
                          },
                        }}
                      />
                    </GridItem>
                    <GridItem xs={12} sm={12} md={12}>
                      <CustomInput
                        success={emailState === "success"}
                        error={emailState === "error"}
                        labelText="Email"
                        id="email"
                        formControlProps={{
                          fullWidth: true,
                        }}
                        inputProps={{
                          value: email,
                          onChange: (event) => {
                            if (verifyEmail(event.target.value)) {
                              setEmailState("success");
                            } else {
                              setEmailState("error");
                            }
                            setEmail(event.target.value);
                          },
                          type: "email",
                        }}
                      />
                    </GridItem>
                    <GridItem xs={12} sm={12} md={12}>
                      <CustomInput
                        labelText="Institution"
                        id="institution"
                        formControlProps={{
                          fullWidth: true,
                        }}
                        inputProps={{
                          value: institution,
                          onChange: (event) => {
                            setInstitution(event.target.value);
                          },
                        }}
                      />
                    </GridItem>
                    <GridItem xs={12} sm={12} md={12}>
                      <CustomInput
                        labelText={
                          "Please describe intended use of common data elements (Max Characters: 1000)"
                        }
                        id="description"
                        formControlProps={{
                          fullWidth: true,
                        }}
                        inputProps={{
                          multiline: true,
                          rows: 5,
                          maxLength: 1000,
                          value: description,
                          onChange: (event) => {
                            setDescription(event.target.value);
                          },
                        }}
                      />
                    </GridItem>
                  </GridContainer>

                  <Button
                    color="info"
                    className={classes.updateProfileButton}
                    type="submit"
                    disabled={
                      !(
                        emailState == "success" &&
                        email.length > 0 &&
                        name.length > 0 &&
                        institution.length > 0 &&
                        description.length > 0
                      )
                    }
                  >
                    Submit
                  </Button>
                </form>
              </GridItem>
            </GridContainer>
          </div>
        </DialogContent>
        <DialogActions
          className={classes.modalFooter + " " + classes.modalFooterCenter}
        >
          <Button
            onClick={() => {
              setRequestDataModal(false);
            }}
            color="rose"
            round
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>

      <GridContainer>
        <GridItem xs={12} sm={12} md={12}>
          <Card profile>
            <CardBody profile>
              <div className={classes.size}>
                <h4>Common Data Elements</h4>
                {!submitState && (
                  <h6>
                    To view downloads for common data elements please submit
                    data request
                  </h6>
                )}
                {submitState && (
                  <h6>
                    Download all requested data before exiting this. page.
                    Leaving this page will require a new data request submission
                    to view elements.
                  </h6>
                )}
              </div>
              {!submitState && (
                <Button
                  color="info"
                  className={classes.updateProfileButton}
                  onClick={() => {
                    setRequestDataModal(true);
                  }}
                >
                  Submit Data Request
                </Button>
              )}
              {submitState && (
                <div className={classes.size}>
                  <div className={classes.cardList}>
                    <ul>
                      <li>
                        <a
                          href="/files/PARDS CDES_whole_doc_all_tiers.docx"
                          target="_blank"
                          rel="noopener noreferrer"
                          download
                        >
                          PARDS-focused Common Data Elements (All Tiers)
                        </a>
                      </li>

                      <li>
                        <a
                          href="/files/PARDS CDES_whole_doc_tier_1_minimal_dataset.docx"
                          target="_blank"
                          rel="noopener noreferrer"
                          download
                        >
                          PARDS-focused Common Data Elements (Minimal Dataset)
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              )}
            </CardBody>
          </Card>
        </GridItem>
      </GridContainer>
    </div>
  );
}

CommonDataElements.propTypes = {
  userInfo: PropTypes.object,
};
